export const APPLE_SD_GOTHIC_PRO =
  '"Apple SD Gothic Neo", AppleGothic, "Malgun Gothic", Dotum, "Noto Sans CJK KR", sans-serif';
export const ARIAL = 'Arial, Verdana, Geneva, Helvetica, sans-serif';
export const HELMET = 'Helmet, Freesans, Helvetica, Arial, sans-serif';
export const HELVETICA_CHINESE =
  'Helvetica, Arial, STHeiti, 华文黑体, "Microsoft YaHei", 微软雅黑, SimSun, 宋体';
export const HIRAGINO_KAGU_GOTHIC_PRO =
  '"Hiragino Kaku Gothic Pro", "ﾋﾗギﾉ角ゴPro W3", "MS PGothic", "MS UI Gothic", Helvetica, Arial, sans-serif';
export const NOTO_SANS_TELUGU =
  '"Noto Sans Telugu", "Hind Guntur", Gautami, "Kohinoor Telugu", sans-serif';
export const NOTO_SANS_GUJARATI =
  '"Noto Sans Gujarati", Rasa, "Hind vadodara", Shruti, Gautami, "Gujarati Sangam MN", "Gujarati MT", sans-serif';
export const NOTO_SANS_BENGALI =
  '"Noto Serif Bengali", Helmet, Freesans, Helvetica, Arial, sans-serif';
export const NOTO_SANS_DEVANAGARI =
  '"Noto Sans Devanagari", Hind, "Mukta Vaani", Gautami, "Kohinoor Devanagari", sans-serif';
export const NOTO_SANS_ETHIOPIC =
  '"Noto Sans Ethiopic", Arial, Verdana, Geneva, Helvetica, sans-serif';
export const NOTO_SANS_GURMUKHI =
  '"Noto Sans Gurmukhi", Gautami, "Kohinoor Gurmukhi", sans-serif';
export const NOTO_SANS_SINHALA =
  '"Noto Serif Sinhala", Arial, Verdana, Geneva, Helvetica, sans-serif';
export const NOTO_SANS_TAMIL =
  '"Noto Sans Tamil", Helmet, Freesans, Helvetica, Arial, sans-serif';
export const PADAUK = 'Padauk, Arial, Verdana, Geneva, Helvetica, sans-serif';
export const REITH_SANS = 'ReithSans, Helvetica, Arial, sans-serif';
export const REITH_SERIF = 'ReithSerif, Helvetica, Arial, sans-serif;';
export const REITH_QALAM =
  '"BBC Reith Qalam", "Times New Roman", Arial, Verdana, Geneva, Helvetica, sans-serif';
export const TAHOMA = 'Tahoma, Helmet, freesans, Helvetica, Arial, sans-serif';
